import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Fundamentos del Vino',
    subtitle: 'Todo lo que necesitás saber antes de abrir una botella o atender tu primer cliente',
    desc: 'Historia del vino en Argentina, proceso de elaboración paso a paso, tipos de vinos, terminología técnica explicada en lenguaje simple, introducción a la cata. Con guías de lectura, vocabulario de referencia y material imprimible listo para tener en el mostrador.',
    resuelve: 'El primer contacto con un cliente es decisivo. Este tomo te da la base para hablar con autoridad desde el primer día.',
    resultado: 'Tus clientes sienten que están siendo asesorados por un experto. Eso genera confianza y eso genera ventas.',
    tags: ['HISTORIA', 'ELABORACIÓN', 'TIPOS', 'TERMINOLOGÍA', 'CATA']
  }, {
    id: 2,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Varietales Argentinos',
    subtitle: 'Conocé cada uva como si la hubieras pisado vos mismo',
    desc: 'Malbec, Cabernet Sauvignon, Bonarda, Syrah, Torrontés, Chardonnay y más. Características organolépticas, zonas de producción, perfil de cliente ideal para cada varietal, cómo presentarlo en góndola y cómo describírselo a un cliente en 30 segundos.',
    resuelve: 'Cuando un cliente dice "quiero algo rico pero no sé qué", este tomo te da la respuesta exacta según su perfil y presupuesto.',
    resultado: 'Convertís cada consulta en una venta porque sabés exactamente qué varietal recomendar y por qué.',
    tags: ['MALBEC', 'TORRONTÉS', 'BONARDA', 'PERFIL DE CLIENTE', 'VENTAS']
  }, {
    id: 3,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Regiones Vitivinícolas Argentinas',
    subtitle: 'Argentina tiene el mapa del vino más rico del mundo. Aprendé a venderlo así.',
    desc: 'Mendoza, San Juan, Salta, Patagonia, La Rioja y Catamarca. Características de cada terroir, altitud, clima, diferencias entre subzonas. Con mapas descriptivos, comparativas por región y argumentos de venta para cada origen.',
    resuelve: 'Un cliente que pregunta "¿qué diferencia hay entre un Malbec de Luján y uno de Cafayate?" merece una respuesta que lo deje con la boca abierta... y con una botella en la mano.',
    resultado: 'Tus clientes entienden el valor del origen y están dispuestos a pagar más por un vino cuando entienden por qué es especial.',
    tags: ['MENDOZA', 'SALTA', 'PATAGONIA', 'TERROIR', 'ARGUMENTOS DE VENTA']
  }, {
    id: 4,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Cata y Análisis Sensorial',
    subtitle: 'El tomo que te transforma de vendedor de vino a referente del vino',
    desc: 'Metodología de cata profesional, análisis visual, olfativo y gustativo, vocabulario técnico aplicado, defectos del vino y cómo detectarlos, cómo organizar una cata para tus clientes. Con fichas de práctica y escalas de puntuación.',
    resuelve: 'Saber catar un vino no es solo para sommeliers. Es la herramienta que te permite seleccionar mejor tu stock, asesorar con seguridad y organizar eventos que fidelizan clientes.',
    resultado: 'Podés organizar catas en tu local, describir cada vino con precisión y diferenciarte de cualquier otra vinoteca del barrio.',
    tags: ['CATA', 'ANÁLISIS SENSORIAL', 'VOCABULARIO', 'DEFECTOS', 'EVENTOS']
  }, {
    id: 5,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📗',
    title: 'Maridajes Argentinos',
    subtitle: 'Que cada botella que vendas lleve una historia en la mesa',
    desc: 'Principios del maridaje, carnes y asado argentino, pastas, pescados y mariscos, quesos, postres, tablas rápidas de referencia. Todo con foco en la gastronomía argentina real, no en libros europeos que no aplican acá.',
    resuelve: 'El maridaje es la venta adicional más natural del mundo. Si sabés sugerir el vino para el asado del domingo, vendés dos botellas en lugar de una.',
    resultado: 'Tus clientes te consultan antes de cada comida especial. Eso los convierte en clientes recurrentes que te traen referidos.',
    tags: ['ASADO', 'MARIDAJE', 'QUESOS', 'TABLAS RÁPIDAS', 'VENTA ADICIONAL']
  }, {
    id: 6,
    lightColor: 'bg-[#3a2456]/60',
    borderColor: 'border-[#5b3a85]/80',
    textColor: 'text-slate-200',
    emoji: '⭐',
    title: 'Negocio de Vinoteca',
    subtitle: 'El tomo que cierra el ciclo y convierte tu pasión en un negocio rentable',
    desc: 'Cómo abrir una vinoteca en Argentina, gestión de stock inteligente, atención al cliente de alto valor, estrategias de marketing para vinotecas, redes sociales que venden vino, venta online y canales digitales. Todo adaptado a la realidad del mercado argentino.',
    resuelve: 'Saber de vino no alcanza. Este tomo te da el sistema de negocio para que tu vinoteca sea rentable, organizada y escalable.',
    resultado: 'Pasás de tener una vinoteca que "más o menos funciona" a tener un negocio con estructura, clientes recurrentes y ventas predecibles.',
    tags: ['GESTIÓN', 'STOCK', 'MARKETING', 'REDES SOCIALES', 'VENTA ONLINE'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: '100 Fichas de Degustación Imprimibles',
    valor: '$18.000 ARS',
    desc: '10 modelos de fichas profesionales: Ficha Express, Ficha Completa Profesional, Ficha de Cata a Ciegas, Ficha Comparativa, Ficha de Maridaje, Ficha de Espumantes, Ficha de Blancos y Rosados, Ficha de Vinos de Guarda. Con escalas de puntuación y vocabulario de referencia incluido.'
  }, {
    id: 2,
    title: 'Guía Rápida de Maridajes Argentinos',
    valor: '$15.000 ARS',
    desc: 'La guía imprimible que podés tener en el mostrador y entregar a tus clientes. Vinos por tipo de comida, maridajes clásicos argentinos, sugerencias por ocasión y por presupuesto. Lista para usar el primer día.'
  }, {
    id: 3,
    title: 'Catálogo de Varietales Argentinos',
    valor: '$12.000 ARS',
    desc: 'Fichas visuales de cada varietal con foto, descripción, zona de origen, perfil de sabor y argumento de venta. Ideal para capacitar a tu equipo o para tener como referencia rápida en la atención al cliente.'
  }, {
    id: 4,
    title: 'Plantillas para Redes Sociales de Vinotecas',
    valor: '$10.000 ARS',
    desc: '30 plantillas editables para Instagram y Facebook. Posts de maridaje, presentación de vinos, promociones, frases del vino, historias de cata. Diseñadas para que una vinoteca se vea profesional sin saber de diseño gráfico.'
  }];
  return <section className="py-20 bg-[#1a0d2e]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0d0716]/80 text-slate-200 border border-[#3a2456]/50 font-bold mb-6 text-[16px]" data-id="element-161">
            📗 LOS 6 TOMOS
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-162">
            Un tomo por cada dimensión del mundo del vino
          </h2>
          <p className="text-slate-300 font-medium text-[16px]" data-id="element-163">
            Todo el sistema didáctico resuelto para dueños de vinotecas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-164">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#3a2456] bg-[#0d0716]/80 overflow-hidden shadow-lg hover:shadow-xl hover:border-slate-400/30 transition-all flex flex-col h-full relative" data-id="element-165">
              {tomo.badge && <div className="absolute top-0 right-0 bg-slate-200 text-slate-950 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-166">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-167">
                <div className="text-3xl" data-id="element-168">{tomo.emoji}</div>
                <div data-id="element-169">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-170">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-171">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-172">
                <p className="font-semibold text-slate-300 mb-3 pb-3 border-b border-[#3a2456]" data-id="element-173">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-174">
                  {tomo.desc}
                </p>
                <div className="bg-[#1a0d2e]/50 p-3 rounded-lg mb-4 border border-[#3a2456]/50" data-id="element-175">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-176">
                    <strong data-id="element-177">¿Qué resuelve en tu vinoteca?</strong>
                  </p>
                  <p className="text-sm text-slate-300" data-id="element-178">{tomo.resuelve}</p>
                </div>
                <div className="bg-purple-900/20 p-3 rounded-lg mb-4 border border-purple-800/30" data-id="element-179">
                  <p className="text-xs text-purple-300 mb-1" data-id="element-180">
                    <strong data-id="element-181">Resultado:</strong>
                  </p>
                  <p className="text-sm text-slate-200" data-id="element-182">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-183">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#3a2456] text-slate-300 px-2 py-1 rounded" data-id="element-184">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#3a2456] pt-16" data-id="element-185">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0d0716]/80 text-slate-200 border border-slate-400/30 font-bold mb-6 text-[16px]" data-id="element-186">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-187">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-188">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#3a2456] bg-[#0d0716]/80 p-6 flex flex-col h-full relative overflow-hidden" data-id="element-189">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-400 to-slate-200" data-id="element-190"></div>
              <h4 className="font-bold text-slate-300 mb-2 mt-2" data-id="element-191">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-192">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-slate-400 mb-4 pb-3 border-b border-[#3a2456]" data-id="element-193">
                Valor real: <span className="line-through" data-id="element-194">{bono.valor}</span> →{' '}
                <span className="text-slate-200" data-id="element-195">GRATIS</span>
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-196">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-br from-[#1a0d2e] to-[#3a2456] rounded-2xl p-6 md:p-8 border border-slate-400/30 text-center shadow-2xl" data-id="element-197">
          <p className="text-slate-300 font-medium mb-2" data-id="element-198">
            Valor total de los 4 bonos: $55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-199">
            Tu precio hoy: <span className="text-slate-200" data-id="element-200">🎁 GRATIS</span> con
            tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}